import type { ListBuilderList } from '../../../types';
import { createShopStandardColumns } from '../columns';
import {
	SHOP_MOBILE_CARD_CONFIG,
	SHOP_STANDARD_REQUIRED_FIELDS,
} from '../shared';

/**
 * Shop Recommended list configuration
 * AI-recommended items the client hasn't purchased yet, that have
 * proven demand (>=3 distinct customers in the last 12 months) AND
 * are currently in stock.
 *
 * The `in_stock` filter is included by default because recommending
 * out-of-stock items wastes a click — the user can't add them to a
 * cart. Without this filter, the backend's existing in-stock check
 * (client-item.service.ts:615-616) never fires for this tab.
 *
 * Kept aligned with the Item Insights "Recommended" tab
 * (client-item-history/lists/recommended.ts +
 * clients.service.ts:getRecommendedItems) so the two surfaces show
 * the same set of items per PD-13622 / PD-13453.
 */
export const shopRecommendedList: ListBuilderList = {
	id: 'shop_recommended',
	cacheTTL: 600000,
	name: 'Recommended',
	type: 'default',
	active: true,
	sortOrder: 6,
	columns: createShopStandardColumns(),
	description: 'AI-recommended items for the client',
	defaultSortId: 'column-item_details-asc',
	requiredFields: SHOP_STANDARD_REQUIRED_FIELDS,
	mobileCardConfig: SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'recommended',
					label: 'Recommended',
				},
				{
					id: 'in_stock',
					label: 'In Stock',
				},
			],
		},
	},
};
